export const isVideoType = (url: string): boolean => {
  return /\.(mp4|mov| quicktime)/.test(url);
};

export const isImageType = (url: string): boolean => {
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)/.test(url);
};

export const isAudioType = (url: string): boolean => {
  return /\.(mp3)/.test(url);
};
